import { Box, Button, Paper, Typography, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LoginIcon from "@mui/icons-material/Login";
import { useLocation } from "react-router-dom";
import { useVerifyEmail } from "../../hooks/query/useUser";
import FallbackLoader from "../../components/loading/FallBackLoader";
import CancelIcon from "@mui/icons-material/Cancel";

const EmailVerified = () => {
  const theme = useTheme();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");

  if (!token) {
    throw new Error("token not found");
  }

  console.log(token);

  const { data, error, isLoading } = useVerifyEmail(token);
  console.log(data);

  if (isLoading) {
    return <FallbackLoader />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f4f8 0%, #e6eaf0 100%)",
        padding: 2,
      }}
    >
      <Paper
        elevation={10}
        sx={{
          width: "100%",
          maxWidth: "450px",
          borderRadius: theme.spacing(3),
          padding: theme.spacing(4),
          background: "linear-gradient(145deg, #f0f4f8 0%, #e6eaf0 100%)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          position: "relative",
          overflow: "hidden",
          transition: "transform 0.3s ease",
          "&:hover": {
            transform: "scale(1.02)",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-50px",
            left: "-50px",
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #bb0000 0%, #bb0000 100%)",
            opacity: 0.1,
          }}
        />

        <Box
          sx={{
            textAlign: "center",
            marginBottom: theme.spacing(3),
            position: "relative",
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 3,
            }}
          >
            {error ? (
              <CancelIcon
                sx={{
                  fontSize: "6rem",
                  color: "#ffffff",
                  background:
                    "linear-gradient(45deg, #bb0000 0%, #bb0000 100%)",
                  borderRadius: "50%",
                  padding: 1,
                  boxShadow: "0 4px 15px rgba(187, 0, 0, 0.2)",
                }}
              />
            ) : (
              <CheckCircleIcon
                sx={{
                  fontSize: "6rem",
                  color: "#bb0000",
                  background: "rgba(187, 0, 0, 0.1)",
                  borderRadius: "50%",
                  padding: 1,
                  boxShadow: "0 4px 15px rgba(187, 0, 0, 0.2)",
                }}
              />
            )}
          </Box>

          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              color: theme.palette.text.secondary,
              marginBottom: 2,
            }}
          >
            {error ? "Email Failed to Verify" : "Email Verified"}
          </Typography>

          <Typography
            variant="body1"
            color="textSecondary"
            sx={{
              marginBottom: 3,
              lineHeight: 1.6,
            }}
          >
            {!error &&
              `Congratulations! Your email has been successfully verified. You can
            now proceed to log in and access your account.`}
          </Typography>

          <Button
            variant="contained"
            fullWidth
            href={error ? "/register" : "/login"}
            startIcon={<LoginIcon />}
            sx={{
              borderRadius: theme.spacing(2),
              padding: theme.spacing(1.5),
              background: "linear-gradient(45deg, #bb0000 0%, #bb0000 100%)",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease",
              textTransform: "none",
              "&:hover": {
                transform: "scale(1.02)",
                boxShadow: "0 6px 8px rgba(0,0,0,0.15)",
              },
            }}
          >
            {error ? "Go to register" : "Go to Login Page"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default EmailVerified;
